module.exports = __webpack_public_path__ + "assets/media/import-suggestion-icon.f7a84e45.svg";